import {
  GET_NEWS_LIST_LOADING,
  GET_NEWS_LIST_SUCCESS,
  GET_NEWS_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { newsListUrl } from "api/apiUrls";

export const newsListAction = (page?: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: GET_NEWS_LIST_LOADING, payload: true });
    const response = await listItemsService(
      `${newsListUrl}`,
      `page_no=${page}&page_size=8`
    );

    dispatch({ type: GET_NEWS_LIST_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: GET_NEWS_LIST_FAILURE, payload: err });
  } finally {
    dispatch({ type: GET_NEWS_LIST_LOADING, payload: false });
  }
};
